"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isString = _interopRequireDefault(require("../object/isString"));

var _isFunction = _interopRequireDefault(require("../object/isFunction"));

/**
 * Trim end of string
 */
var trimEnd = function trimEnd(string) {
  if (!(0, _isString["default"])(string)) {
    throw new Error('Value needs to be a string');
  }

  if ((0, _isFunction["default"])(string.trimEnd)) {
    return string.trimEnd();
  }

  return string.replace(/\s+$/, '');
};

var _default = trimEnd;
exports["default"] = _default;